import { useUserDashboardApiFetchListingExtras } from '#/modules/userDashboard/api/listingExtras/userDashboardApiFetchListingExtras';
import { useLoggedIn } from '#/contexts/UserEnvironmentContext';
import type { ApiOrgId } from '#/api/types/ApiTypedId';

type Args = {
  orgId: ApiOrgId | undefined;
};

export function useUserDashboardOrgInitiallySaved({ orgId }: Args) {
  const { loggedIn } = useLoggedIn();
  const [savedOrgListingExtras] = useUserDashboardApiFetchListingExtras(
    loggedIn && orgId ? [orgId] : [],
  );

  return {
    orgInitiallySaved:
      loggedIn && orgId && savedOrgListingExtras
        ? Boolean(savedOrgListingExtras[orgId])
        : false,
  };
}
